import React from 'react'

import styled from 'styled-components'
import { VideoComponent } from '@/components/VideoComponent'
import { Button } from 'antd'
import { Container } from '@/components'
import { themeGet } from '@styled-system/theme-get'
import Image from 'next/image'

const ServiceVideoIntroWrapper = styled.div`
	padding: 80px 0 120px;
	background-color: #fdfdff;
	text-align: center;

	@media (max-width: 1200px) {
		padding: 48px 20px 96px;
	}
	@media (max-width: 768px) {
		padding: 48px 0;
	}

	.top {
		display: flex;
		align-items: center;
		justify-content: center;

		@media (max-width: 410px) {
			display: block;
		}
	}

	.desc-box {
		display: flex;
		justify-content: space-between;
		gap: 16px;
		margin-top: 58px;
		padding: 28px 64px 48px;
		background-color: #f0fafc;

		@media (max-width: 1200px) {
			padding-left: 16px;
			padding-right: 16px;
		}
		@media (max-width: 768px) {
			display: block;
			padding: 8px 16px 36px;
			margin-top: 24px;
		}

		.desc-item {
			width: 275px;

			@media (max-width: 1200px) {
			}
			@media (max-width: 768px) {
				width: 100%;

				&:not(:nth-of-type(1)) {
					margin-top: 16px;
				}
			}

			img {
			}

			p {
				color: ${themeGet('text.0', '#1B1B29')};
				line-height: 1.35;
				margin: 0;
			}

			.title {
				font-size: 24px;
				font-weight: 900;
				margin-top: 10px;

				@media (max-width: 1200px) {
					font-size: 22px;
				}
				@media (max-width: 768px) {
					font-size: 20px;
				}
			}

			.desc {
				font-size: 20px;
				font-weight: normal;
				margin-top: 24px;

				@media (max-width: 1200px) {
					font-size: 18px;
				}
				@media (max-width: 1000px) {
					br {
						display: none;
					}
				}
				@media (max-width: 768px) {
					font-size: 16px;
					margin-top: 16px;
				}
			}
		}
	}
`

const TitleWrapper = styled.div`
	font-size: 48px;
	font-weight: bold;
	color: ${themeGet('text.0', '#1B1B29')};
	text-align: center;
	line-height: 1.35;

	@media (max-width: 1200px) {
		font-size: 48px;
	}
	@media (max-width: 768px) {
		font-size: 28px;
	}
	@media (max-width: 410px) {
		font-size: 24px;
	}
`

const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	gap: 24px;
	letter-spacing: -0.5px;
	margin-top: 40px;
	margin-right: 96px;

	@media (max-width: 1200px) {
		margin-right: 0;
	}
	@media (max-width: 768px) {
		margin-top: 24px;

		.ant-btn {
			span {
				font-size: 14px;
				vertical-align: text-bottom;
			}
		}
	}
	@media (max-width: 410px) {
		justify-content: end;

		a {
			display: block;
			width: 100%;

			.ant-btn {
				width: 100%;
			}
		}
	}
`

const CTAButton = styled(Button)`
	flex: 1;
	height: 56px;
	color: #ffffff;
	font-weight: bold;
	padding: 0 32px;
	box-shadow: none;
	border-radius: 2px;
	border: 0;
	background-color: ${themeGet('primary.1', '#00bfc8')};

	&.ant-btn-primary:not(:disabled):hover {
		background-color: #113ac3;
	}

	span {
		display: inline-block;
		vertical-align: bottom;
		font-size: 20px;
		font-weight: bold;
		color: #fff;
	}

	img {
		display: inline-block;
		vertical-align: text-bottom;
		width: 24px;
		height: 24px;
		margin-right: 10px;
	}

	@media (max-width: 1200px) {
	}
	@media (max-width: 768px) {
		height: 48px;
		padding: 0 24px;

		img {
			vertical-align: top;
			width: 20px;
			height: 20px;
		}
	}
	@media (max-width: 410px) {
		img {
			vertical-align: baseline;
			width: 16px;
			height: 16px;
			margin-right: 4px;
		}
	}
`

const VideoWrapper = styled.div`
	margin-top: 96px;

	video {
		display: block;
		max-width: 800px;
		margin: 0 auto;
		border: solid 1px #eaeae8;
	}

	@media (max-width: 1200px) {
		padding: 0 56px;
	}
	@media (max-width: 768px) {
		padding: 0;
		margin-top: 48px;
	}
`

export const IntroVideo: React.FC<{}> = ({}) => {
	return (
		<ServiceVideoIntroWrapper>
			<Container>
				<div className="top">
					<TitleWrapper>
						좋은 교재, <br />더 잘 쓰이도록
					</TitleWrapper>
					{/*
					<ButtonWrapper>
						<Link target={'_blank'} href={'/static/files/[쏠북] 서비스 소개서.pdf'}>
							<CTAButton>
								<Image
									src={'/static/assets/icon_download.svg'}
									alt={'다운로드'}
									width={24}
									height={24}
								/>
								서비스 소개서
							</CTAButton>
						</Link>
					</ButtonWrapper>
					*/}
				</div>
				<div className="desc-box">
					<div className="desc-item">
						<Image
							src={'/static/assets/img-service-01.svg'}
							alt={'아이콘'}
							width={120}
							height={120}
						/>
						<p className="title">당당하게 이용</p>
						<p className="desc">
							비싸고 복잡했던 라이선싱이 <br />
							플랫폼 거래로 간편해 집니다.
						</p>
					</div>
					<div className="desc-item">
						<Image
							src={'/static/assets/img-service-02.svg'}
							alt={'아이콘'}
							width={120}
							height={120}
						/>
						<p className="title">편리하게 가공</p>
						<p className="desc">
							교재 중심의 현장 교육에 최적화한 <br />
							콘텐츠 이용툴을 제공합니다.
						</p>
					</div>
					<div className="desc-item">
						<Image
							src={'/static/assets/img-service-03.svg'}
							alt={'아이콘'}
							width={120}
							height={120}
						/>
						<p className="title">활발하게 거래</p>
						<p className="desc">
							현장 교육에서 생성되는 <br />
							다양한 교육콘텐츠를 수익화합니다.
						</p>
					</div>
				</div>
				<VideoWrapper>
					<VideoComponent
						videoSrc={'/static/videos/230105_solvookCI.mp4'}
						posterSrc={'/static/assets/video_poster.jpg'}
					/>
				</VideoWrapper>
			</Container>
		</ServiceVideoIntroWrapper>
	)
}
